import { useState } from "react";
import { Search, AlertTriangle, CheckCircle2, FlaskConical } from "lucide-react";

const PRESETS = [
  { label: "Prova con sfratto", nome: "Giuseppe", cognome: "Verdi", data: "14/03/1982", testid: "preset-sfratto" },
  { label: "Prova senza precedenti", nome: "Laura", cognome: "Bianchi", data: "02/09/1991", testid: "preset-pulito" },
];

export const SearchSimulator = () => {
  const [form, setForm] = useState({ nome: "", cognome: "", data: "" });
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const verify = () => {
    setResult(null);
    const nome = form.nome.trim().toLowerCase();
    const cognome = form.cognome.trim().toLowerCase();
    if (!nome || !cognome) return setError("Inserisci almeno Nome e Cognome per la prova.");
    setError("");
    setResult(nome === "giuseppe" && cognome === "verdi" ? "danger" : "ok");
  };

  return (
    <div data-testid="search-simulator-card" className="rounded-2xl border border-slate-200 bg-white/95 p-6 shadow-[0_24px_60px_-20px_rgba(23,37,84,0.35)] backdrop-blur-xl sm:p-8">
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-2 text-lg font-bold text-[#1e3a8a]"><Search className="h-5 w-5" />Prova la Ricerca Anagrafica</h3>
        <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-amber-700">
          <FlaskConical className="h-3 w-3" />Demo
        </span>
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        {PRESETS.map((p) => (
          <button key={p.testid} data-testid={p.testid} type="button" className="rounded-full border border-slate-200 px-3 py-1 text-xs font-semibold text-slate-600 hover:border-[#2563eb] hover:text-[#2563eb]"
            style={{ transition: "color 160ms, border-color 160ms" }}
            onClick={() => { setForm({ nome: p.nome, cognome: p.cognome, data: p.data }); setResult(null); setError(""); }}>
            {p.label}
          </button>
        ))}
      </div>
      <div className="mt-5 space-y-4">
        <div><label className="field-label">Nome Candidato</label><input data-testid="input-search-nome" className="field-input" placeholder="es. Giuseppe" value={form.nome} onChange={set("nome")} /></div>
        <div><label className="field-label">Cognome Candidato</label><input data-testid="input-search-cognome" className="field-input" placeholder="es. Verdi" value={form.cognome} onChange={set("cognome")} /></div>
        <div><label className="field-label">Data di Nascita</label><input data-testid="input-search-data-nascita" className="field-input" placeholder="GG/MM/AAAA" value={form.data} onChange={set("data")} /></div>
      </div>
      <button data-testid="button-verifica-database" className="btn-accent mt-6 w-full" onClick={verify}>Verifica nel Database</button>
      {error && <p data-testid="search-simulator-error" className="mt-3 text-sm font-medium text-[#dc2626]">{error}</p>}
      {result === "danger" && (
        <div data-testid="search-result-alert" data-result="danger" className="fade-up mt-5 flex gap-3 rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-800">
          <AlertTriangle className="h-5 w-5 shrink-0" />
          <p><strong>Segnalazione Presente:</strong> Risulta un provvedimento esecutivo di Convalida di Sfratto emesso dal Tribunale.</p>
        </div>
      )}
      {result === "ok" && (
        <div data-testid="search-result-alert" data-result="ok" className="fade-up mt-5 flex gap-3 rounded-xl border border-green-200 bg-green-50 p-4 text-sm text-green-800">
          <CheckCircle2 className="h-5 w-5 shrink-0" />
          <p><strong>Nessun Precedente:</strong> Nessuno sfratto certificato in archivio per questo soggetto.</p>
        </div>
      )}
      <p className="mt-4 text-[11px] leading-relaxed text-slate-400">Simulazione dimostrativa con dati fittizi. La ricerca reale è disponibile nella WebApp dopo l'accesso.</p>
    </div>
  );
};
